import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Session } from 'src/app/models/session';

@Component({
  selector: 'app-view-session',
  templateUrl: './view-session.component.html',
  styleUrls: ['./view-session.component.scss'],
})
export class ViewSessionComponent implements OnInit {

  @Input() session : Session;
  
  constructor(
    public modalCtrl : ModalController,
  ) { }

  ngOnInit() {
  }

  confirm(){
    this.modalCtrl.dismiss();
  }

  cancel(){
    this.modalCtrl.dismiss();
  }

}
